import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import Footer from '../../Layout/Footer';
import Header from '../../Layout/Header';
import feedback from '../../../assets/img/notify.jpg';
import moment from 'moment';
import { browsetaskBuyer, browsetaskSearchBuyer, getTaskCategoryList } from '../../../Redux/Task/action';
import { IMAGE_URL } from '../../../api';
import Pagination from '../../Pagination';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Form } from 'react-bootstrap';
import MultiRangeSlider from "multi-range-slider-react";
import { FaRupeeSign } from 'react-icons/fa';
// import { Card } from 'react-bootstrap';
// import { BiTimeFive } from 'react-icons/bi';
// import { BsGlobe } from 'react-icons/bs';
// import { AiOutlineCalendar } from 'react-icons/ai';
// import { FaRupeeSign } from 'react-icons/fa';
// import taskimage from '../../assets/img/taskimg.png';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import loader from '../../../assets/img/loader.gif';

const BrowseTasksBuyer = () => {

    const params = useParams()
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [pageStatus, setPageStatus] = useState(1);
    const [totalPageNumber, setTotalPageNumber] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [categories, setCategories] = useState();
    const [isloader, setIsloader] = useState(false);

    const initialValues = {
        category: '',
        status_object: '',
    };


    const __search = (e) => {
        setIsloader(true)

        const status_object = formik.values.status_object || "";
        const category = formik.values.category || "";
        // let status_object = localStorage.getItem('status_object');
        // let category = localStorage.getItem('category');
        // if (formik.values.status_object) {
        //     status_object = formik.values.status_object
        // }
        // if (formik.values.category) {
        //     category = formik.values.category
        // }

        browsetaskSearchBuyer(e?.target?.value, currentPage, 10, formik.values.category, status_object)((response) => {
            if (response?.status && response?.data) {
                if ((response?.data?.data.length) >= response?.data?.count) {

                    setHasMore(false)
                }
                setIsloader(false)
                setData(response?.data?.data)
                localStorage.setItem('status_object', status_object);
                localStorage.setItem('category', category);
            }
        });
    }
    const __redirect = (task) => {

        if (task?.status?.status == "open") {
            navigate('/mytasklistingbuyer', { state: { data: task } })
        }
        else if (task?.status?.status == "assigned") {
            navigate('/mytaskassignedbuyer', { state: { data: task } })
        }
        else {
            navigate('/mytaskcompletedbuyer', { state: { data: task } })
        }
    }
    useEffect(() => {

        browsetaskBuyer(currentPage, 9)((response) => {
            if (response?.status && response?.data) {
                if ((response?.data?.data.length) >= response?.data?.count) {
                    setHasMore(false)
                }
                setData(response?.data?.data)
                setTotalPageNumber(response?.data?.total_pages)
            }
        });
        getTaskCategoryList()((response) => {
            if (response && response.status) {
                setCategories(response?.data?.data)
            }
        });
    }, []);
    const validationSchema = Yup.object().shape({

    });
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: (values) => {
            // let formData = new FormData();
            // values.filterdate_from &&
            //     formData.append("filterdate_from", values.filterdate_from);
            // values.filterdate_to &&
            //     formData.append("filterdate_to", values.filterdate_to);
            // formData.append("filterprice_from", minValue);
            // formData.append("filterprice_to", maxValue);
            // formData.append("status_object", values.status_object);
            // formData.append("category", values.category);
            // formData.append("sort_order", values.sort_order);
            // formData.append("sub_category", values.sub_category);
            // formData.append("limit", values.limit);
            __search()
        },
    });

    const clearAll = () => {

        formik.setValues({
            status_object: "",
            category: "",
        });
        localStorage.removeItem('category');
        localStorage.removeItem('status_object');
    }
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const paginate = () => {
        let status_object = localStorage.getItem('status_object');
        let category = localStorage.getItem('category');
        if (formik.values.status_object) {
            status_object = formik.values.status_object
        }
        if (formik.values.category) {
            category = formik.values.category
        }
        browsetaskBuyer(page, 9, formik.values.category, status_object)((response) => {
            if (response.status) {

                if ((data.length + response?.data?.data.length) >= response?.data?.count) {

                    setHasMore(false)
                }
                setData(data.concat(response?.data?.data))
            }
            else {

                setHasMore(false)
            }
        })
        setPage(page + 1)
    }
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Browse Tasks </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Browse Tasks</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='logodesign-details'>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-4 col-lg-2 sidebar-filter">
                            <Form onSubmit={formik.handleSubmit}>
                                <div className='logodesign-details-filter mb-4'>
                                    <h3 className="mt-0 mb-3">Filters</h3>
                                    <h4 onClick={() => { clearAll() }} className="mt-0 mb-3" role="button">CLEAR ALL</h4>
                                </div>

                                <Form.Select value={formik.values.category || ""} aria-label="Default select example" className="mb-3" name='category' onChange={formik.handleChange} >
                                    <option value='' disabled hidden>Choose category</option>
                                    {categories?.map((category, index) =>
                                        <option key={index} value={category?.id}>{category?.name}</option>
                                    )}
                                </Form.Select>
                                <Form.Select value={formik.values.status_object || ""} aria-label="Default select example" name='status_object' onChange={formik.handleChange} className="mb-3">
                                    <option value='' disabled hidden>Status</option>
                                    <option value="1" >Opened </option>
                                    <option value="2">Assigned</option>
                                    <option value="3">Completed</option>
                                </Form.Select>
                                {/* <Form.Select value={filterbydate} aria-label="Default select example" onChange={(e) => handleSelectChange(e)} className="mb-3">
                                    <option>Filter by</option>
                                    <option value="All" >All </option>
                                    <option value="Today">Daily</option>
                                    <option value="Weekly">Weekly</option>
                                    <option value="Monthly">Monthly</option>
                                    <option value="Period">Period</option>

                                </Form.Select> */}

                                <div className='filter-btn mt-4'>
                                    {isloader == true ?
                                        <div className='loader'>
                                            <img src={loader} alt="" className='img-fluid' />
                                        </div>
                                        :
                                        <button type="submit" className="btn btn-primary mb-4">Apply Filter</button>
                                    }
                                </div>


                            </Form>
                        </div>
                        <div className='col-lg-10 col-md-8'>
                            <section className='browse-tasks'>
                                <div className='container'>
                                    <div className='row'>
                                        <div className='col-lg-12'>
                                            <div className='browse-tasks-title'>
                                                <h3>Browse tasks</h3>
                                                <p>Check out what tasks people want done near you right now...</p>
                                            </div>
                                            <div className='col-lg-12'>
                                                <div className="search-form d-flex align-items-center justify-content-center">
                                                    {/* <form className="search-form d-flex align-items-center justify-content-center" > */}
                                                    <input type="text" name="query" placeholder="Search" title="Search" onChange={(e) => __search(e)} className='' />
                                                    <button type="submit" title="Search">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" className='search-icon searchlist-icon' fill="#fff" viewBox="0 0 16 16">
                                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                                        </svg>
                                                    </button>
                                                    {/* </form> */}
                                                </div>
                                            </div>
                                            <div className="mytask-buyer section-bg p-0">
                                                <InfiniteScroll
                                                    dataLength={data.length}
                                                    next={paginate}
                                                    hasMore={hasMore}
                                                    loader={<p style={{ textAlign: 'center' }}>
                                                        <b>Loading...</b>
                                                    </p>}
                                                    endMessage={
                                                        <p style={{ textAlign: 'center' }}>
                                                            <b>Yay! You have seen it all</b>
                                                        </p>
                                                    }
                                                >
                                                    <div className="container">
                                                        <div className="row mt-4">
                                                            {data?.map((task, index) =>
                                                                <React.Fragment>
                                                                    <div className="col-lg-4">
                                                                        <div className='' onClick={() => __redirect(task)}>
                                                                            <div className="member d-flex align-items-start">
                                                                                <div className='col-lg-2'>
                                                                                    {task?.status?.status == "open" ?
                                                                                        <div className="pic_serach"><img src={IMAGE_URL + task?.image?.image} className="" alt="" /></div>
                                                                                        :
                                                                                        < div className="pic_serach"><img src={IMAGE_URL + task?.assigned_to[0]?.image} className="" alt="" /></div>
                                                                                    }
                                                                                </div>
                                                                                <div className='col-lg-10'>
                                                                                    <div className="member-info">
                                                                                        <div className='task_title_main'>
                                                                                            <h4>{task?.title}</h4>
                                                                                        </div>
                                                                                        {task?.location == "" ?
                                                                                            <></>
                                                                                            :
                                                                                            <p><i class="bi bi-geo-alt-fill me-2"></i> {task?.location}</p>
                                                                                        }
                                                                                        <p><i className="bi bi-calendar me-2"></i> {moment(task?.date_choice).format('ll')}</p>
                                                                                        <p><i className="bi bi-clock me-2"></i>{task?.time_slot == 1 ? "Before 10 AM" : task?.time_slot == 2 ? "10 AM - 2 PM" : task?.time_slot == 3 ? "2 PM - 6 PM" : task?.time_slot == 4 && "After 6 PM"}</p>
                                                                                        <div className='badge-w-set'>
                                                                                            <span className="badge badge-light-success me-2">{task?.status?.status}</span>
                                                                                        </div>

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    </div>
                                                </InfiniteScroll>
                                            </div>
                                            {/* <div className='browse-tasks-tasks'>
                                <div className='row'>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                </div>

                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div >
                </div >
            </section >
            {/* <Pagination setCurrentPage={setCurrentPage} total_pages={totalPageNumber} /> */}
            < Footer />
        </React.Fragment >
    )
}

export default BrowseTasksBuyer;